import { writable } from "svelte/store";
import constants from "@/constants";
const { NO_MORE_POSTS_OFFSET } = constants;
const initialState = {
  list: [],
  offset: undefined,
};
const { subscribe, update } = writable(initialState);
/**
 *
 * @param {Array} posts
 * @param {String} offset
 * @returns {Object}
 */

const updateState = ({ posts, offset }) =>
  update((oldState) => {
    let newList = oldState.list;
    if (Array.isArray(posts)) {
      newList = [...newList, ...posts];
    }
    return {
      list: newList,
      offset: offset || NO_MORE_POSTS_OFFSET,
    };
  });

export default {
  subscribe,
  updateState,
};
